import React from 'react';

import Popover from 'components/Popover';
import { REGENERATE_TEXT_OPTIONS } from './constants';
import { OnGenerateClipName, RegenerateTextValues } from './types';

export type RenameClipModalRegeneratePopoverProps = {
  triggerElement: HTMLButtonElement;
  isOpen: boolean;
  onGenerateClipName: OnGenerateClipName;
  onClose: () => void;
};

const RenameClipModalRegeneratePopover: React.FC<RenameClipModalRegeneratePopoverProps> = ({
  triggerElement,
  isOpen,
  onGenerateClipName,
  onClose,
}) => {
  return (
    <Popover {...{ triggerElement, isOpen, onClose }} variant="form">
      <Popover.RadioGroup
        options={REGENERATE_TEXT_OPTIONS}
        ctaLabel="regenerate"
        defaultValue={{
          formality: 'neutral',
          tone: 'direct',
        }}
        onAction={(selectedValue: RegenerateTextValues) =>
          onGenerateClipName(selectedValue.formality, selectedValue.tone)
        }
      />
    </Popover>
  );
};

export default RenameClipModalRegeneratePopover;
